'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MdBrightness2 = function MdBrightness2(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm16.6 3.4c9.3 0 16.8 7.4 16.8 16.6s-7.5 16.6-16.8 16.6c-3 0-5.8-0.7-8.2-2.1 5-2.9 8.2-8.3 8.2-14.5s-3.2-11.6-8.2-14.5c2.4-1.4 5.2-2.1 8.2-2.1z' })
        )
    );
};

exports.default = MdBrightness2;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/md/brightness-2.js
// module id = 1252
// module chunks = 168707334958949